import React from "react";

import one from "../img/one.svg";
import two from "../img/two.svg";
import three from "../img/three.svg";
import four from "../img/four.svg";

import box from "../img/box.svg";
import sides from "../img/sides.svg";
import rules from "../img/rules.svg";

import StoreLinks from "./storeLinks";

export default () => (
  <div className="guide">
    <h2>Guide</h2>

    <p>
      Code Sculpture allows you to create 3D art from simple rules. Get started
      by creating a new project.
    </p>

    <p>Download now to follow along. It is free</p>

    <StoreLinks iOSStoreLink="https://itunes.apple.com/us/app/code-sculpture/id1286544769" />

    <p>
      A project is just a set of rules (or instructions). The first instruction
      is the starting shape for your sculpture. If it helps think of it as a
      digital piece of clay.
    </p>

    <img src={one} />

    <p>
      Each 3D shape has a set of faces. A cube has 6 square faces. We can sculpt
      our 'digital clay' by applying a rule to each face.
    </p>

    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "space-between"
      }}
    >
      <img src={box} style={{ width: 200, height: 200 }} />

      <img src={sides} style={{ width: 200, height: 200 }} />
    </div>

    <p>So to each of the above faces we can apply one of the below rules</p>

    <img src={rules} />

    <p>
      Let's make a simple tree. We start with a cube, then we want to apply a
      rule to the top face. But we want to make this next shape bigger, for
      example by doubling the scale.
    </p>

    <img src={two} />

    <p>
      Let's add a pyramid on top, replacing our flat surface with this new
      shape.
    </p>

    <img src={three} />

    <p>
      Done! We have made a simple tree. Tap on the play button (in Code
      Sculpture) to manipulate this in 3D, step through the construction steps
      and (on supported devices) place your tree in the real world with AR.
    </p>

    <img src={four} />

    <p>
      By composing simple rules you can create really interesting, beautiful
      objects which have never existed before.
    </p>

    <p>
      <em>James Porter</em>
    </p>

    <br />

    <br />

    <StoreLinks iOSStoreLink="https://itunes.apple.com/us/app/code-sculpture/id1286544769" />

    <h2>Video Demo</h2>

    <p>A little demo of some of the new features added in 1.1</p>

    <br />

    <iframe
      width="480"
      height="270"
      style={{ margin: "auto", display: "block" }}
      src="https://www.youtube.com/embed/-KhaZfouGwc"
      frameBorder="0"
      gesture="media"
      allowFullScreen
    />

    <h2>Isometrically</h2>

    <p>
      The guide images above were created in{" "}
      <a href="https://isometrically.amimetic.co.uk">
        <strong>Isometrically</strong>
      </a>, an iPad and iPhone App for creating Isometric (3D-ish) graphics.
    </p>

    <a href="https://isometrically.amimetic.co.uk" className="button-style">
      Learn More about Isometrically
    </a>

    <br />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/guide.js